import React from "react";
import { Grid, Typography } from "@mui/material";
import { DashoardServiceData } from "./DashboardServiceData";
import navigateImage from "assets/images/navigateImage.svg";


function DashboardPages() {
  return (
    <Grid container>
      <Grid
        item
        container
        justifyContent="center"
        alignItems="center"
        className="dashboardImg height270"
        spacing={2}
      >
        <Grid item 
        className='dashboardAlign' 
        md={7.4} xs={12}>
          <Typography className="navigateTextFont">
            Navigating Opportunities, Uniting Drivers
          </Typography>
          <Typography className="font18 marginInline10">
            Join a community of dedicated drivers, where each mile takes you
            closer to your dreams
          </Typography>
        </Grid>
        <Grid container item  md={3} xs={12}>
          <Grid item>
            <img src={navigateImage} alt="navigate" />
          </Grid>
        </Grid>
      </Grid>
      <Grid
        item
        direction="column"
        className="iterBg"
        md={11.7}
        xs={11}
      >
        <Grid item>
          <Typography className="heading marginTop25">
            There's an ITER Home for everyone
          </Typography>
        </Grid>
        <Grid
          container
          item
          xs={11}
          justifyContent="space-evenly"
          direction="row"
          alignItems="center"
          className="marginBlock30 paddingBlock25"
        >
          {DashoardServiceData?.map((service) => (
            <Grid
              item
              justifyContent="space-evenly"
              alignItems="center"
              md={3}
              sm={6}
              xs={12}
              key={service.id}
              className="pb30"
            >
              <img src={service.image} alt="car" />
              <Typography className="dashboardFont">
                {service.heading}
              </Typography>
              <Typography className="colorGrey font14">
                {service.desc}
              </Typography>
            </Grid>
          ))}
        </Grid>
      </Grid>
    </Grid>
  );
}

export default DashboardPages;
